export default __webpack_public_path__ + "static/media/aspire.f3153126.jpg";